module.exports = __webpack_public_path__ + "img/CrueltyFreeOutlined.d7d179ca.svg";